import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {fetchManagementReportFilters} from 'app/actions/ManagementReportActions';
import { getManagementReportFilters, getIsLoadingManagementReportFilters } from 'app/reducers';
import isEmpty from 'app/utils/IsEmpty';


export default function ManagementReportContainer(props) {
    const {idSubdirection} = useSelector(state => state.Auth.employeeById);
    let managementFilters = useSelector(getManagementReportFilters);

    let isLoading = useSelector(getIsLoadingManagementReportFilters);
    const dispatch = useDispatch();

    useEffect(() => {
        if (isEmpty(managementFilters)) fetchManagementReportFiltersAction();
    }, []);

    const fetchManagementReportFiltersAction = () => dispatch(fetchManagementReportFilters({idSubdirection:idSubdirection}))
    return (props.children({managementFilters, isLoading }));
}


